import { gql } from "@apollo/client"

export const GET_PROGRAMS = gql`
  query Programs($staff_id: ID!, $organization_id: ID!) {
    programs: getProgramsByUid(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      program_identity_id
      program_id_name
      program_id_status
      program_id_create_date
      program_id_change_date
      organization_id
      organization_name
      program_id_gpra
    }
  }
`

export const GET_PROGRAMS_BY_ENTERPRISE_ID = gql`
  query Programs($staff_id: ID!, $enterprise_id: ID!, $organization_id: ID!) {
    programs: getProgramsListByEnterpriseId(
      staff_id: $staff_id
      enterprise_id: $enterprise_id
      organization_id: $organization_id
    ) {
      program_identity_id
      program_id_name
      program_id_status
      organizations
      program_id_creator
      program_id_enterprise_managed
      program_id_gpra
    }
  }
`
export const GET_PROGRAMS_BY_CTX = gql`
  query Programs($staff_id: ID!, $organization_id: ID!) {
    programs: programsByOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      program_identity_id
      program_id_name
      program_id_status
      program_id_create_date
      program_id_change_date
      organization_id
      organization_name
      program_id_code
      program_id_creator
      program_id_enterprise_managed
      program_id_gpra
    }
  }
`

export const CHANGE_STATUS_PROGRAM = gql`
  mutation ChangeStatusProgram(
    $staff_id: String!
    $staff_alias: String!
    $program_identity_id: String!
    $program_id_status: String!
  ) {
    changeProgramStatus(
      staff_id: $staff_id
      staff_alias: $staff_alias
      program_identity_id: $program_identity_id
      program_id_status: $program_id_status
    ) {
      program_identity_id
    }
  }
`

export const GET_PARTICIPANT_BY_PROGRAM = gql`
  query participantsByProgram(
    $staff_id: ID!
    $program_identity_id: ID!
    $condiction: Boolean
  ) {
    participantsByProgram: participantsByProgram(
      staff_id: $staff_id
      program_identity_id: $program_identity_id
      condiction: $condiction
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_membership_status
      participant_name_preferred
    }
  }
`
export const GET_ORGANIZATIONS = gql`
  query Organizations($staff_id: ID!, $organization_id: ID!) {
    organizations: statsOrganizationsByUid(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      organization_id
      organization_name
      organization_status
      current_staff_users
      current_participants
      current_programs
      current_locations
      organization_id_stamp
    }
  }
`
